export const MVP_ACTIONS = {
    'SET_CURRENT_USER_ID': 'SET_CURRENT_USER_ID',
    'SET_CURRENT_USER': 'SET_CURRENT_USER',
    'SET_USER_PROFILE': 'SET_USER_PROFILE',
    'SET_ACTIVE_SESSION': 'SET_ACTIVE_SESSION',
    'UNSUBSCRIBE': 'UNSUBSCRIBE',
}

export default MVP_ACTIONS;